var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('q-input',{attrs:{"debounce":600,"after":[
      {
        icon: null,
        handler: function handler() {
          _vm.onSearch(_vm.searchModel)
        }
      }
    ],"icon":"none","color":"light","bg-color":"white","placeholder":"Search list...","outlined":"","dense":"","input-class":"search-input","hide-bottom-space":""},on:{"input":function($event){return _vm.onSearch(_vm.searchModel)}},model:{value:(_vm.searchModel),callback:function ($$v) {_vm.searchModel=$$v},expression:"searchModel"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }